export default class SimpleRadioButtonModel {
    constructor(
        labelText: string,
        radioValue: string,
        /** Voidaan käyttää esim rightslotTemplaten tallentamiseen jos useammalla radiobuttonilla on sama rightslot */
        groupName?: string,
        id?: number | null) {
            this.labelText = labelText
            this.radioValue = radioValue
            this.groupName = groupName
            this.id = id
    }

    labelText!: string
    radioValue!: string
    groupName?: string = ""
    id?: number | null
}
